exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fs11[data-v-2e1adb6d] {\n  font-size: 11px;\n}\n", ""]);

// exports
